import { render, staticRenderFns } from "./SerieView.vue?vue&type=template&id=2d12951b&scoped=true&"
import script from "./SerieView.vue?vue&type=script&lang=js&"
export * from "./SerieView.vue?vue&type=script&lang=js&"
import style0 from "./SerieView.vue?vue&type=style&index=0&id=2d12951b&prod&scoped=true&lang=css&"
import style1 from "./SerieView.vue?vue&type=style&index=1&id=2d12951b&prod&scss=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d12951b",
  null
  
)

export default component.exports